import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'

import { ActionMenuDialogItem } from '../ActionMenuDialogItem/ActionMenuDialogItem'
import { MenuItemLike, WithSnackbarMessages } from '../index.types'

type Props<Data extends Record<string, unknown>> = MenuItemLike & {
  onDelete: (row: Data) => Promise<void> | void
  isDeletable?: (row: Data) => boolean
  confirmationMessage?: ((row: Data) => string) | string
} & WithSnackbarMessages<Data>

/** Component to be used as a base for creating new ActionDeleteItems if messages need to be overwritten. NOT for standalone use (eg. ActionDeleteTranscoderItem) */
export const ActionDeleteItem = <Data extends Record<string, unknown>>({
  displaySeparately,
  errorMessage = 'Failed to delete item',
  successMessage = 'Item deleted successfully',
  confirmationMessage = 'Are you sure you want to delete this item? This action cannot be undone.',
  onDelete,
  isDeletable,
  overrideText
}: Props<Data>) => {
  return (
    <ActionMenuDialogItem
      displaySeparately={displaySeparately}
      errorMessage={errorMessage}
      successMessage={successMessage}
      confirmationMessage={confirmationMessage}
      onClick={onDelete}
      isClickable={isDeletable}
      overrideText={overrideText || 'Delete Item'}
      label="Delete"
      icon={<DeleteOutlineOutlinedIcon />}
    />
  )
}
